var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 150 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,45.098039%,72.941176%)",
      fillOpacity: 1
    },
    d: "M 12.558594 153.085938 L 0 0.285156 L 150 0.59375 L 136.71875 153.085938 L 75.566406 170.714844 Z M 12.558594 153.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.980392%,53.333333%,78.039216%)",
      fillOpacity: 1
    },
    d: "M 75.566406 155.957031 L 75.566406 14.839844 L 137.335938 15.042969 L 126.320312 141.300781 Z M 75.566406 155.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.996094 32.875 L 26.972656 32.875 L 29.546875 51.320312 L 74.640625 51.320312 L 30.269531 70.28125 L 32.839844 88.113281 L 98.214844 88.113281 L 95.847656 113.015625 L 73.714844 117.320312 L 53.636719 112.195312 L 52.09375 98.054688 L 33.664062 98.054688 L 36.136719 127.464844 L 75.667969 138.433594 L 113.554688 126.441406 L 118.394531 68.949219 L 78.34375 68.949219 L 121.996094 50.914062 Z M 121.996094 32.875 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.3c07cfe0a85fbc241ade5018dcf0d4db.svg";
export { ForwardRef as ReactComponent };